export var UNIFIED_ACTION;
(function (UNIFIED_ACTION) {
    UNIFIED_ACTION["CREATE_PRE_APPLICATION"] = "CREATE-PRE-APPLICATION";
    UNIFIED_ACTION["PATCH_PRE_APPLICATION"] = "PATCH-PRE-APPLICATION";
    UNIFIED_ACTION["VALIDATE_UNDERWRITER"] = "VALIDATE-UNDERWRITER";
    UNIFIED_ACTION["CREATE_APPLICATION"] = "CREATE-APPLICATION";
    UNIFIED_ACTION["VALIDATE_QUESTION_LATEST"] = "VALIDATE-QUESTION-LATEST";
    UNIFIED_ACTION["SHOW_QUESTIONS_TO_FE"] = "SHOW-QUESTIONS-TO-FE";
    UNIFIED_ACTION["PATCH_APPLICATION"] = "PATCH-APPLICATION";
    UNIFIED_ACTION["CREATE_QUOTE"] = "CREATE-QUOTE";
    UNIFIED_ACTION["WAIT_FOR_QUOTE_WH_INITIAL"] = "WAIT-FOR-QUOTE-WH-INITIAL";
    UNIFIED_ACTION["FETCH_COVERAGE_AND_ACK_QUESTIONS"] = "FETCH-COVERAGE-AND-ACK-QUESTIONS";
    UNIFIED_ACTION["FETCH_COVERAGE_QUESTIONS"] = "FETCH-COVERAGE-QUESTIONS";
    UNIFIED_ACTION["SHOW_COVERAGE_QUESTIONS_TO_FE"] = "SHOW-COVERAGE-QUESTIONS-TO-FE";
    UNIFIED_ACTION["PATCH_COVERAGE_QUESTIONS"] = "PATCH-COVERAGE-QUESTIONS";
    UNIFIED_ACTION["WAIT_FOR_QUOTE_WH_AFTER_COVERAGE_ACK"] = "WAIT-FOR-QUOTE-WH-AFTER-COVERAGE-ACK";
    UNIFIED_ACTION["FETCH_ACK_QUESTIONS"] = "FETCH-ACK-QUESTIONS";
    UNIFIED_ACTION["SHOW_ACK_QUESTIONS_TO_FE"] = "SHOW-ACK-QUESTIONS-TO-FE";
    UNIFIED_ACTION["PATCH_ACK_QUESTIONS"] = "PATCH-ACK-QUESTIONS";
    UNIFIED_ACTION["SHOW_QUOTE_TO_FE"] = "SHOW-QUOTE-TO-FE";
})(UNIFIED_ACTION || (UNIFIED_ACTION = {}));
